<template>
  <div>
    <InfoDetail v-if="pageStatus === 'infoDetail'" @changeToCertVerify="changeToCertVerify()"></InfoDetail>
    <CertVerify v-if="pageStatus === 'certVerify'" @changeToInfoDetail="changeToInfoDetail()"></CertVerify>
  </div>
</template>
<script>
import InfoDetail from "./infoDetail/InfoDetail";
import CertVerify from "./certVerify/CertVerify";
export default {
  name: "PersonInfo",
  components: {
    InfoDetail,
    CertVerify,
  },
  data() {
    return {
      tabListNoTitle: [],
      pageStatus: "infoDetail",
    };
  },
  methods: {
    changeToCertVerify() {
      this.pageStatus = "certVerify";
    },
    changeToInfoDetail() {
      this.pageStatus = "infoDetail";
    },
  },
};
</script>

<style>
</style>